import { Accordion as MantineAccordion, Title } from "@mantine/core";
import { ReactNode } from "react";

export const Accordion = (props: {
  items: { value: string; content: ReactNode }[];
  opened: string;
  setOpened: (title: string) => void;
}) => {
  return (
    <MantineAccordion value={props.opened ?? null}>
      {(props.items ?? []).map(item => {
        return (
          <MantineAccordion.Item key={item.value} value={item.value}>
            <MantineAccordion.Control>
              <Title order={2} onClick={() => props.setOpened(item.value)}>
                {item.value}
              </Title>
            </MantineAccordion.Control>
            <MantineAccordion.Panel>{item.content}</MantineAccordion.Panel>
          </MantineAccordion.Item>
        );
      })}
    </MantineAccordion>
  );
};
